export const SET_DEFAULT_PROVINCE = 'src/store/auth/SET_DEFAULT_PROVINCE';
export const SET_DEFAULT_CITY = 'src/store/auth/SET_DEFAULT_CITY';
